import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { Cliente } from '../../types/estoque';
import { clientesService, enderecosService, tiposEntidadeService } from '../../services';
import { makeOptionLoader } from '../../utils/optionLoaders';

const fields: ResourceField<Cliente>[] = [
  { name: 'razao_social', label: 'Razão social', required: true },
  { name: 'nome_fantasia', label: 'Nome fantasia' },
  {
    name: 'tipo_pessoa',
    label: 'Tipo de pessoa',
    type: 'select',
    options: [
      { label: 'Pessoa jurídica', value: 'PJ' },
      { label: 'Pessoa física', value: 'PF' },
    ],
    required: true,
  },
  { name: 'documento', label: 'Documento (CPF/CNPJ)' },
  { name: 'numero', label: 'Número', required: true },
  {
    name: 'tipos',
    label: 'Tipos de entidade',
    type: 'async-select',
    multiple: true,
    valueType: 'number[]',
    loadOptions: makeOptionLoader(
      tiposEntidadeService.list,
      (item: any) => item.descricao ?? item.codigo ?? String(item.id),
    ),
    helperText: 'Inclua CLIENTE para identificar como cliente.',
  },
  { name: 'email', label: 'E-mail' },
  { name: 'telefone', label: 'Telefone' },
  {
    name: 'endereco',
    label: 'Endereço',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      enderecosService.list,
      (item: any) => {
        const partes = [item.logradouro, item.bairro, item.cidade_nome, item.cep].filter(Boolean);
        return partes.length ? partes.join(', ') : `Endereço #${item.id}`;
      },
    ),
    helperText: 'Selecione um endereço cadastrado.',
  },
];

export const ClientesFormPage: React.FC = () => (
  <ResourceFormPage
    title="Novo cliente"
    description="Cadastre clientes para expedição."
    fields={fields}
    service={clientesService}
    redirectPath="/admin/estoque/clientes"
    cancelPath="/admin/estoque/clientes"
  />
);
